module.exports = __webpack_public_path__ + "img/metal_ap@2x.83741e30.png";